import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-summary',
	path: '/projects/:projectKey/settings/automation/',
};
